import React from 'react';
import * as MyCells from '../../../../../utils/Cells';
import ActionMenu from '../../../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../../common/filters/DateRangeColumnFilter';
import { MultiSelectFilterFn } from '../../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';
import * as enums from '../../../../../utils/EnumMapping';
import StatusCell from '../../../../common/cells/StatusCell';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../../common/filters/StateMultiSelectColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'stateLabel',
            id: 'stateLabel',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Sorszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Munkavállaló',
            accessor: 'employeeName',
            id: 'employeeName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Fizetési mód',
            accessor: 'paymentMethodLabel',
            id: 'paymentMethodLabel',
            show: true,
            className: 'iconColumn',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
            Cell: props => <MyCells.IconCell label={props.value} list={enums.paymentMethods} />,
        },
        {
            Header: 'Dátum',
            accessor: 'date',
            id: 'date',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Nettó összeg',
            accessor: 'netAmount',
            id: 'netAmount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Bruttó összeg',
            accessor: 'grossAmount',
            id: 'grossAmount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'dividend'} refresh={refresh} />,
        },

    ]
}